document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.powermax-payback-calculator')) {
    import(
      /* webpackChunkName: "powermax-payback" */ '/Features/Calculators/PowermaxPaybackCalculator/powermax-payback-calculator.js'
    ).then(async (module) => {
      const powermaxPaybackCalculator = new module.default();
      await powermaxPaybackCalculator.init();
    });
  }
});
